// extracted by mini-css-extract-plugin
export default {"screen":"screen__+IlJD","screenViewport":"screenViewport__KwM4S","block":"block__hr5Gl","blockFlex":"blockFlex__MQWJW"};